import { computed } from 'vue';
import { FormItemRule } from 'element-plus';
import { storeToRefs } from 'pinia';
import {
  payoutOrderListFilterFormRef,
  usePayoutOrderListFilterStore,
} from '@/store/payout-order/payout-order-filter-list.store';
import { PayoutOrderListFilter } from '@/models/payout-order/payout-order-list-filter.model';

export const usePayoutOrderListFilterFormRules = () => {
  const {
    isFilterTagIdListNotEmpty,
    isFilterSegmentIdListNotEmpty,
    isFilterPaymentSystemListNotEmpty,
    isFilterCountryListNotEmpty,
  } = storeToRefs(usePayoutOrderListFilterStore());

  const rulesProperty: FormItemRule = {
    message: 'Required',
    trigger: ['change', 'blur'],
  };

  const clearConditionValidation = (prop: keyof PayoutOrderListFilter): void => {
    payoutOrderListFilterFormRef.value?.clearValidate(prop);
  };

  const payoutOrderListFilterFormRules = computed<Record<string, FormItemRule[]>>(() => {
    return {
      paymentSystemListCondition: [{
        ...rulesProperty,
        required: isFilterPaymentSystemListNotEmpty.value,
      }],
      countryListCondition: [{
        ...rulesProperty,
        required: isFilterCountryListNotEmpty.value,
      }],
      segmentIdListCondition: [{
        ...rulesProperty,
        required: isFilterSegmentIdListNotEmpty.value,
      }],
      tagIdListCondition: [{
        ...rulesProperty,
        required: isFilterTagIdListNotEmpty.value,
      }],
    };
  });

  return {
    payoutOrderListFilterFormRules,
    clearConditionValidation,
  };
};
